import React from "react";

import { DocumentView } from "@components";

export const Document = () => {
    return (
        <div>
            <DocumentView />
        </div>
    );
};
